/*!
 * Volan product image zoom (client spec item 4).
 *
 * Tapping or clicking a product image opens the full-screen viewer: Dawn's
 * product-media-modal, which already provides the close button, prev/next
 * arrows and slide dots the client asked for on both desktop and mobile.
 *
 * Why reuse the modal rather than scaling in place: the reference is a
 * full-bleed viewer with navigation, not a magnified crop inside the page. Dawn's
 * viewer already has the controls, focus trapping and keyboard handling
 * styled for this theme.
 *
 * Only images open the viewer. Video, 3D and external media keep Dawn's own
 * behaviour, untouched.
 *
 * Notes
 *   - No hover behaviour at all, by design.
 *   - `data-media-id` on this element tells Dawn's viewer which slide to
 *     open, so tapping slide 4 opens slide 4 rather than always the first.
 *   - Escape is handled by Dawn's ModalDialog; nothing to do here.
 */
(() => {
  if (customElements.get('volan-zoom')) return;

  class VolanZoom extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.zoomModal) return;

      this.onActivate = this.onActivate.bind(this);
      // A single delegated listener covers mouse and touch alike. The wrapper
      // is not a button, so nothing else on the tile has to change.
      this.addEventListener('click', this.onActivate);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onActivate);
    }

    onActivate(event) {
      // Ignore taps that started on a control layered over the image.
      if (event.target.closest('button, a, input, select')) return;

      const selector = this.dataset.zoomModal;
      const modal = selector ? document.querySelector(selector) : null;
      if (!modal || typeof modal.show !== 'function') return;

      // Dawn reads data-media-id off the opener to pick the active slide, so
      // hand it this element rather than the raw tap target.
      modal.show(this);
    }
  }

  customElements.define('volan-zoom', VolanZoom);
})();